import { useEffect } from 'react'
import { ROOT_PATH } from '@/app/router/paths'
import { useAppPath } from './useAppPath'

export function useBackGuard() {
  const rootPath = useAppPath(ROOT_PATH)

  useEffect(() => {
    function onPopState() {
      window.location.replace(rootPath)
    }

    window.addEventListener('popstate', onPopState)

    return () => {
      setTimeout(() => {
        window.removeEventListener('popstate', onPopState)
      }, 0)
    }
  }, [rootPath])
}
